(function () {
  if (window.LPWDeliveryDates) return;

  const DEFAULTS = {
    warehouseTimeZone: 'America/New_York',
    cutoffMinutes: 780
  };

  const addDays = (date, days) => {
    const result = new Date(date);
    result.setUTCDate(result.getUTCDate() + Math.max(0, days));
    return result;
  };

  const getWarehouseDateTime = (date = new Date(), options = {}) => {
    const settings = { ...DEFAULTS, ...options };
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: settings.warehouseTimeZone,
      weekday: 'short',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hourCycle: 'h23'
    }).formatToParts(date).reduce((acc, part) => {
      acc[part.type] = part.value;
      return acc;
    }, {});

    return {
      year: Number(parts.year),
      month: Number(parts.month),
      day: Number(parts.day),
      hour: Number(parts.hour),
      minute: Number(parts.minute),
      weekday: ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'].indexOf(parts.weekday.toLowerCase())
    };
  };

  const getNextFulfillmentDate = (date) => {
    let result = new Date(date);
    while (result.getUTCDay() === 0 || result.getUTCDay() === 6) {
      result = addDays(result, result.getUTCDay() === 6 ? 2 : 1);
    }
    return result;
  };

  const getNextDispatchDate = (date = new Date(), options = {}) => {
    const settings = { ...DEFAULTS, ...options };
    const warehouse = getWarehouseDateTime(date, settings);
    let result = new Date(Date.UTC(warehouse.year, warehouse.month - 1, warehouse.day, 12));

    if (warehouse.weekday === 0) {
      return getNextFulfillmentDate(addDays(result, 1));
    }

    if (warehouse.weekday === 6) {
      return getNextFulfillmentDate(addDays(result, 2));
    }

    if ((warehouse.hour * 60) + warehouse.minute >= settings.cutoffMinutes) {
      result = addDays(result, 1);
    }

    return getNextFulfillmentDate(result);
  };

  const addDeliveryDays = (date, days) => {
    let result = new Date(date);
    let remaining = Math.max(0, days);

    while (remaining > 0) {
      result = addDays(result, 1);
      if (result.getUTCDay() !== 0) remaining -= 1;
    }

    return result;
  };

  const getDeliveryDateRange = (minDays, maxDays, options = {}) => {
    const dispatchDate = getNextDispatchDate(options.date || new Date(), options);

    return {
      startDate: addDeliveryDays(dispatchDate, minDays),
      endDate: addDeliveryDays(dispatchDate, maxDays),
      dispatchDate
    };
  };

  const formatDeliveryDateRange = (minDays, maxDays, options = {}) => {
    const { startDate, endDate } = getDeliveryDateRange(minDays, maxDays, options);
    const locale = options.locale || document.documentElement.lang || undefined;
    const formatter = new Intl.DateTimeFormat(locale, {
      weekday: 'long',
      month: 'short',
      day: 'numeric',
      timeZone: 'UTC'
    });

    if (options.singleDate) return formatter.format(endDate);
    return `${formatter.format(startDate)} - ${formatter.format(endDate)}`;
  };

  const refreshArrivalWindows = (root = document) => {
    const windows = root.querySelectorAll?.('[data-delivery-arrival-window]:not([data-arrival-window-ready])');
    if (!windows?.length) return;

    windows.forEach((windowEl) => {
      const minDays = Number.parseInt(windowEl.dataset.minDays || '', 10);
      const maxDays = Number.parseInt(windowEl.dataset.maxDays || '', 10);
      const singleDate = windowEl.dataset.singleDate === 'true';
      const rangeEl = windowEl.querySelector('strong');
      if (!rangeEl || !Number.isFinite(minDays) || !Number.isFinite(maxDays)) return;

      rangeEl.textContent = formatDeliveryDateRange(minDays, maxDays, { singleDate });
      windowEl.dataset.arrivalWindowReady = 'true';
    });
  };

  window.LPWDeliveryDates = {
    addDays,
    addDeliveryDays,
    formatDeliveryDateRange,
    getDeliveryDateRange,
    getNextDispatchDate,
    getNextFulfillmentDate,
    getWarehouseDateTime,
    refreshArrivalWindows
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => refreshArrivalWindows(), { once: true });
  } else {
    refreshArrivalWindows();
  }

  document.dispatchEvent(new CustomEvent('lpw:delivery-dates:ready'));
}());
